import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, firstValueFrom } from 'rxjs';

interface AuthConfig {
  authority: string;
  clientId: string;
  redirectUri: string;
  apiUri: string,
  apiClientId: string
}

@Injectable({ providedIn: 'root'})
export class IdentityService {
    private configUrl = environment.configUrl;// Update this to match your actual endpoint

    constructor(private http: HttpClient) {}

    // Fetch the config as an observable (useful elsewhere if needed)
    getAuthConfig(): Observable<AuthConfig> {
        const headers = new HttpHeaders().set('x-app-bootstrap-key', environment.bootstrapKey);
        return this.http.get<AuthConfig>(this.configUrl, { headers });
    }


    // Use this during app initialization
    async initializeAuthConfig(): Promise<void> {
        try {
        const config = await firstValueFrom(this.getAuthConfig());
        environment.azureId = {
            authority: config.authority,
            clientId: config.clientId,
            redirectUri: config.redirectUri,
            apiUri: config.apiUri,
            apiClientId: config.apiClientId
        };
        } catch (error) {
        console.error('Failed to initialize MSAL config:', error);
        }
    }
}